import { TxpGriffinSettingsPayload } from 'owa-calendar-configuration';
import TxpSettingsEntryPoint from '../store/schema/TxpSettingsEntryPoint';

export default function getTxpSettingsSaveCustomData(
    body: TxpGriffinSettingsPayload,
    entryPoint: TxpSettingsEntryPoint
) {
    const {
        FlightReservation,
        FoodEstablishmentReservation,
        LodgingReservation,
        RentalCarReservation,
        ParcelDelivery,
        EventReservation,
        Invoice,
        ServiceReservation,
    } = body.EntityTypeSettings;

    return {
        FlightReservation: FlightReservation && FlightReservation.ProcessingLevel,
        FoodEstablishmentReservation:
            FoodEstablishmentReservation && FoodEstablishmentReservation.ProcessingLevel,
        LodgingReservation: LodgingReservation && LodgingReservation.ProcessingLevel,
        RentalCarReservation: RentalCarReservation && RentalCarReservation.ProcessingLevel,
        ParcelDelivery: ParcelDelivery && ParcelDelivery.ProcessingLevel,
        EventReservation: EventReservation && EventReservation.ProcessingLevel,
        Invoice: Invoice && Invoice.ProcessingLevel,
        ServiceReservation: ServiceReservation && ServiceReservation.ProcessingLevel,
        entryPoint: entryPoint,
        createEventsAsPrivate: body.CreateEventsFromEmailAsPrivate,
    };
}
